import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import AsyncTableComponent from './AsyncTableComponent';

import { SET_LIST_PARAMS } from '../../actionConstants';

import { getIsTouchDevice, getLaunchDateFromLocation } from '../../utils';
import { formatTextSelect } from '../Forms/utils';

import * as commonSelectors from '../Shared/selectors';

import ErrorBoundary from '../Main/ErrorBoundary';

const AsyncTableContainer = (props) => (
  <ErrorBoundary>
    <AsyncTableComponent {...props} />
  </ErrorBoundary>
);

const mapStateToProps = (state, ownProps) => {
  const { common, router, buildings, modal, todayCount } = state;
  const {
    dateRangeTypeOptions,
    defaultParams,
    listKey,
    searchAutoFocus = true,
  } = ownProps;

  const defaultPaginationValue = common?.currentUser?.defaultPaginationLimit;
  let defaultParamsWithPagination = null;
  if (defaultPaginationValue && defaultParams) {
    defaultParamsWithPagination = defaultParams;
    defaultParamsWithPagination.limit = defaultPaginationValue;
  }
  const listParams = commonSelectors.getListParams(state, listKey);
  const isMobileScreen = commonSelectors.getIsMobileScreen(state);

  const location = router?.location?.pathname;
  const buildingLaunchDate = getLaunchDateFromLocation(location, buildings);
  const isCustomModalShown = modal?.isCustomModalShown;
  const isLoading = commonSelectors.getIsLoading(state);
  const isAutoFocusEnabled = getIsTouchDevice() ? false : searchAutoFocus;

  return {
    isLoading,
    isDrawerOpen: state?.common?.isDrawerOpen,
    dateRangeTypeOptions: formatTextSelect(dateRangeTypeOptions),
    listParams,
    buildingLaunchDate,
    isCustomModalShown,
    todayCount,
    defaultParams: defaultParamsWithPagination,
    isMobileScreen,
    searchAutoFocus: isAutoFocusEnabled,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  setListParams: (queryParams) =>
    dispatch({
      type: SET_LIST_PARAMS,
      listKey: ownProps?.listKey,
      queryParams,
    }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(AsyncTableContainer));
